import MediaOwner from '@/common/models/media-owner/MediaOwner';
import { QueryParams } from '@/common/models/query-params';
import ExchangeAppAPIProxy from '@/exch-app/api';
import OrgAppAPIProxy from '@/org-app/api';
import { queryKeys } from '@/org-app/services/tanstack/queryKeys';
import { createGetQuery, isCuratorOrExchange } from '@/org-app/services/tanstack/queryUtils';
import orgAppStore from '@/org-app/store';
import { UPDATE_MEDIA_OWNERS_LIST } from '@/org-app/store/modules/referenceData/mutation-types';
import { mapOrgAppGetters } from '@/utils/StateMapping';

export const useMediaOwners = createGetQuery<MediaOwner>(
  [queryKeys.mediaOwners],
  (queryParams: QueryParams = QueryParams.all()) => {
    const { isParentOrganization } = mapOrgAppGetters();
    if (isParentOrganization.value) {
      queryParams.customQueryParams.include_child_orgs = true;
    }
    return isCuratorOrExchange()
      ? ExchangeAppAPIProxy.instance.getSuppliers({ queryParams })
      : OrgAppAPIProxy.instance.getMediaOwners({ queryParams });
  },
  {
    mutation: (data: MediaOwner[]) => {
      orgAppStore.modules.ReferenceData.mutations[UPDATE_MEDIA_OWNERS_LIST](
        orgAppStore.modules.ReferenceData.state,
        data,
      );
    },
    onError: (error) => {
      console.error(error);
    },
  },
);
